import { defineMessages } from 'react-intl';

const coverageIdToName: { [key: string]: any } = defineMessages({
  tpl: { id: 'Third Party Liability' },
  cpd: { id: 'Physical Damage' },
  travel: { id: 'Travel Insurance' },
});

export default coverageIdToName;
